import { useEffect, useState } from "react";
import { zafClient } from "../../service/zendesk";
import { useSetup } from "../../hook/useSetup";

export function useConfigGate() {
    const [loading, setLoading] = useState(true);
    const [isConfigured, setIsConfigured] = useState(false);
    const { loading: setupLoading } = useSetup();

    useEffect(() => {
        async function loadSettings() {
            const metadata = await zafClient.metadata();
            const { apiToken, emailAdmin } = metadata.settings || {};

            const hasBaseConfig = Boolean(apiToken && emailAdmin);
            setIsConfigured(Boolean(apiToken && emailAdmin));
            setLoading(false);
            
            if (!hasBaseConfig) {
                setLoading(false);
                return;
            }

            // se tem config, o loading vai depender do setup
            if (!setupLoading) {
                setLoading(false);
            }

        }

        loadSettings();
    }, []);

    return {
        loading,
        isConfigured
    }
}